import { OccConfig, OccEndpoints } from '@spartacus/core';

export const nonBuyingPhysicianApiConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        nbpAccount:
          '/customer-register/de/non-buying-physician-account-information',
        validateNbpAccount:
          '/customer-register/de/non-buying-physician-account-information-validation',
        registerNbpAccount:
          '/customer-register/de/non-buying-physician-information',
      } as OccEndpoints,
    },
  },
};
